import * as smsAuthApi from '../services/api/smsAuth';

export const SHOW_VERIFY_CODE_INPUT = 'SHOW_VERIFY_CODE_INPUT';
export const HIDE_VERIFY_CODE_INPUT = 'HIDE_VERIFY_CODE_INPUT'
export const SET_SMS_AUTH_ERRORS = 'SET_SMS_AUTH_ERRORS';
export const UPDATE_SMS_AUTH_STATUS = 'UPDATE_SMS_AUTH_STATUS';

export function sendToken(params){
    return dispatch => {
        const success = response => {
            if(response.payload === "pending"){
                dispatch(showVerifyCodeInput());
            }
        }

        const fail = errors => {
            dispatch(setErrors(errors.payload));
        }

        return smsAuthApi
            .sendToken(params)
            .then(success, fail);
    }
}

export function verifySmsCode(params){
    return dispatch => {
        const success = response => {
            if(response.payload === "approved"){
                if(params.isUpdate){
                    dispatch(updateSmsAuthDetails(params));
                }else{
                    dispatch(createUserSmsAuth(params));
                }
                dispatch(updateSmsAuthStatus(response.payload));

            }else{
                // the code that was input is incorrect so we need to send an error message indicating this.
                const error = {
                    'sms_code': ['The verification code does not match']
                }

                dispatch(setErrors(error))
            }
        }

        const fail = errors => {
            dispatch(setErrors(errors.payload));
        }

        return smsAuthApi
            .verifySmsCode(params)
            .then(success, fail);
    }
}

function updateSmsAuthDetails(params){
    return dispatch => {
        const success = response => {
            console.log(response.payload);
        }

        const fail = errors => {
            dispatch(setErrors(errors.payload));
        }

        return smsAuthApi
            .updateSmsAuthDetails(params)
            .then(success)
    }
}

function createUserSmsAuth(params){
    return dispatch => {
        const success = response => {
            console.log(response.payload);
        }

        const fail = errors => {
            dispatch(setErrors(errors.payload));
        }

        return smsAuthApi
            .saveSmsAuthNumber(params)
            .then(success, fail);
    }
}

function showVerifyCodeInput(){
    return {
        type: SHOW_VERIFY_CODE_INPUT
    }
}

export function hideVerifyCodeInput(){
    return {
        type: HIDE_VERIFY_CODE_INPUT
    }
}

function setErrors(errors){
    return {
        type: SET_SMS_AUTH_ERRORS,
        errors
    }
}

function updateSmsAuthStatus(smsAuthStatus){
    return {
        type: UPDATE_SMS_AUTH_STATUS,
        smsAuthStatus
    }
}